import React, { useState } from 'react'
import ArrowNext from '../../../../assets/ArrowNext'
import CalendarIcon from '../../../../assets/CalendarIcon'
import { COLORS } from '../../../../styles/colors'
import { DateInputProps } from '../../types'
import {
	ArrowIconWrapper,
	IconWrapper,
	InputText,
	InputWrapper,
	StyledDateInput,
} from './DateInput.styles'

/**
 * Компонент инпута для отображения и выбора даты
 * Отображает текстовое поле с иконкой календаря
 * При клике открывает календарь для выбора даты
 */
const DateInput = React.forwardRef<HTMLDivElement, DateInputProps>(
	(
		{
			value,
			placeholder = 'Выберите дату',
			isOpen,
			isActive = false,
			variant = 'primary',
			disabled = false,
			onClick,
		},
		ref,
	) => {
		const [isHovered, setIsHovered] = useState(false)

		const handleClick = () => {
			if (!disabled) {
				onClick()
			}
		}

		const getIconColor = () => {
			if (disabled) return COLORS.secondary
			if (isHovered || isOpen || isActive) return COLORS.main
			return COLORS.icon
		}

		// Текст для отображения: value или placeholder
		const displayText = value || placeholder
		const isEmpty = !value

		return (
			<StyledDateInput
				ref={ref}
				$variant={variant}
				$disabled={disabled}
				onClick={handleClick}
				onMouseEnter={() => !disabled && setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
			>
				<InputWrapper
					$isOpen={isOpen}
					$isActive={isActive}
					$disabled={disabled}
				>
					<IconWrapper>
						<CalendarIcon width={20} height={20} color={getIconColor()} />
					</IconWrapper>
					<InputText
						$isHovered={isHovered}
						$isOpen={isOpen}
						$isActive={isActive}
						$isEmpty={isEmpty}
					>
						{displayText}
					</InputText>
					<ArrowIconWrapper>
						<ArrowNext
							width={20}
							height={20}
							color={getIconColor()}
							direction={isOpen ? 'up' : 'down'}
						/>
					</ArrowIconWrapper>
				</InputWrapper>
			</StyledDateInput>
		)
	},
)

DateInput.displayName = 'DateInput'

export default DateInput
